import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import { push } from 'react-router-redux';

import { tryToUpdateTeamSignature, tryToFetchMyTeams  } from '../../actions/actions.export.js';
import Button from '../Button/Button.js'
import CustomField from '../CustomField/CustomField.js'


import generateFullDownloadableText from '../../pattern_utilities/generateFullDownloadableText.js'


class TeamSettingsSignatureForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    var t = props.team.cache[props.id] || {};

    this.state = {
      signature: props.team.updateTeamSignatureForm.lastSubmit.signature || t.signature
    }

    this.handleUpdateTeamSignature = this.handleUpdateTeamSignature.bind(this);
  }

  componentWillMount(){
    const { dispatch, team, id } = this.props;

    if(!team.cache[id] || new Date().getTime() - team.cache[id].lastFetch < 2000){
      dispatch(tryToFetchMyTeams());
    }
  }

  componentWillReceiveProps(newprops){
    var t = newprops.team.cache[newprops.id];

    if(this.state.signature === undefined){
      this.setState({
        signature: newprops.team.updateTeamSignatureForm.lastSubmit.signature || t.signature
      })
    }
  }

  handleUpdateTeamSignature(e){
    if(e) e.preventDefault();

    const { dispatch, team } = this.props;

    var t = team.cache[this.props.id];

    dispatch(tryToUpdateTeamSignature({
      id: t.id,
      signature: this.state.signature
    }))
  }

  render(){
    const { dispatch, team, user, change, patternManager } = this.props; 
    const state = this.state;

    var t = team.cache[this.props.id];

    if(!t) return <i className="fal fa-spinner-third fa-spin fa-2x"/>

    let formDisabled = state.signature == t.signature;

    let fakeTeam = JSON.parse(JSON.stringify(t));

    fakeTeam.signature = this.state.signature;

    return (
      <div>
        <form name="TeamSettingsSignatureForm" onSubmit={(e) => {
          e.preventDefault();
          if(!formDisabled) this.handleUpdateTeamSignature(e);
        }}>

          <CustomField 
            type="text"
            name="signature"
            placeholder={"ex:\r\nProperty of " + t.display_name + "\r\n1234 Main St\r\nCity, State 12345\r\n\r\nFor questions please contact us at 555-555-5555 or email@example.com.\r\n"}
            description="This will be inserted at the top of all exported team pattern files."
            label="Signature"
            multipleRows={true}
            minRows={6}
            maxLength={256}
            validIfBlank={true}
            value={this.state.signature}
            onChange={(v) => { this.setState({signature: v}); }}
            serverErrors={team.updateTeamSignatureForm.errors.signature}
            disabled={team.tryingToUpdateTeamSignature}
          />
          <br/>

          <div className="list-right">
            <Button 
              submit={true} 
              size="medium" 
              disabled={formDisabled} 
              thinking={team.tryingToUpdateTeamSignature} 
              successful={team.successfullyUpdatedTeamSignature}
              failed={team.failedToUpdatedTeamSignature}
              color="success" 
              display="Save Changes" 
            />
          </div>
        </form>
        <hr/>
        <div>
          .PAT File Preview: 
          <pre className="text-small">
          {generateFullDownloadableText(patternManager.pristineCache['tutorial_intro_09'], user, fakeTeam, true, true, true, '.pat')}
          </pre>
        </div>
      </div>
    )
  }
}


TeamSettingsSignatureForm = reduxForm({
  form: 'TeamSettingsSignatureForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(TeamSettingsSignatureForm)

TeamSettingsSignatureForm = connect((state, ownProps) => {
  const { team, user, patternManager } = state;

  var t =  team.cache[ownProps.id];

  var initialValues = {
    signature: t ? t.signature : ''
  };
  
  return {
    team,
    patternManager,
    user,
    initialValues
  }
})(TeamSettingsSignatureForm);

export default TeamSettingsSignatureForm;


// WEBPACK FOOTER //
// ./src/components/TeamSettingsSignatureForm/TeamSettingsSignatureForm.js